module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-home-slide-nb-title u-inline-block t-ffamily--simplon u-uppercase u-force-3d",
    class: ['is-' + _vm.color, 'c-home-slide-nb-title--' + _vm.index]
  }, [_c('span', {
    staticClass: "c-home-slide-nb-title__number u-inline-block u-force-3d u-align-left"
  }, [_vm._v(_vm._s(_vm.number) + " /")]), _vm._v(" "), _c('span', {
    staticClass: "c-home-slide-nb-title__label u-inline-block u-force-3d"
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07ffa26e"}!./src/scripts/components/app-home-slide-nb-title/template.html
// module id = 451
// module chunks = 0